/**
 * The reviews-summary service keys products on catalogue id, the public product code
 * minus 10000. Feefo keys on the public code, so nothing outside reviews-summary applies it.
 */
export const PRODUCT_CODE_OFFSET = 10000;
